import React from 'react';
import { GlyphType } from './PreviewGlyphSequence';

type PreviewIndividualGlyphProps = {
  glyphType: GlyphType;
};

const PreviewIndividualGlyph = ({ glyphType }: PreviewIndividualGlyphProps) => (
  <div className={`individualGlyph ${glyphType}Glyph`}>
    <div className="shapeDisplay"/>
    <div className="inputSquare"/>
  </div>
);

export default PreviewIndividualGlyph;